import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/ReportSubscriptionParameters'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class ReportSubscriptionParametersStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "ReportSubscriptionParametersStore",
			variables: true,
		})
	}
}

export async function load_ReportSubscriptionParameters(params) {
  await initClient()

	const store = new ReportSubscriptionParametersStore()

	await store.fetch(params)

	return {
		ReportSubscriptionParameters: store,
	}
}
